export { Slider } from "./slider";
export type { SliderProps } from "./slider";
